import React from 'react'
import { Icon } from '@iconify/react'
import { styled } from '@material-ui/core/styles'
import {
  Card,
  Typography,
  Box,
  Stack,
  withStyles,
  CircularProgress,
} from '@material-ui/core'
import checkmarkFill from '@iconify-icons/eva/checkmark-fill'
import { CoreButton } from 'src/components/core'
import styles from './styles'
import Page from 'src/components/Page'

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme, index, action }) => ({
  maxWidth: 380,
  height: 580,
  padding: 40,
  marginTop: '20px',
  marginBottom: '20px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundColor: action.background,
  boxShadow: 'none',
  '&:hover':
    action.disabled !== true && !action.active
      ? {
          outline: `1px solid ${theme.palette.mcgBlue || '#007BFF'}`,
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
        }
      : 'none',
}))

// ---------------------------------------------------------------------

const RootHeader = styled(Page)(({ theme }) => ({
  width: 300,
  height: 36,
  display: 'flex',
}))

const BoxRoot = styled(Page)(({ index }) => ({
  display: index === 3 ? 'none' : 'flex',
}))

const PricingPlanCard = ({
  card,
  index,
  onClickHandler,
  timeInterval,
  classes,
  length,
  loading,
}) => {
  const { subscription, price, caption, lists, action } = card

  return (
    <RootStyle
      index={index}
      labelAction={action.text}
      subscription={subscription}
      action={action}
    >
      <RootHeader>
        <Typography className={classes.typography}>{subscription}</Typography>
      </RootHeader>
      <Typography
        variant="subtitle2"
        gutterBottom
        component="span"
        className={classes.caption}
      >
        {caption}
      </Typography>

      <BoxRoot index={index} className={classes.boxRoot}>
        <Typography variant="subtitle1" className={classes.dollarText}>
          $
        </Typography>
        <Typography className={classes.priceValue}>
          {price === 0 ? '0' : price}
        </Typography>
        <Typography
          gutterBottom
          component="span"
          variant="subtitle2"
          className={classes.dollarText}
        >
          {timeInterval ? '/month' : '/month'}
        </Typography>
      </BoxRoot>

      <Stack component="ul" spacing={2} className={classes.stackList}>
        {lists.map(item => (
          <Stack
            key={item.text}
            component="li"
            direction="row"
            alignItems="center"
            spacing={1.5}
            className={classes.stack}
          >
            <Box
              component={Icon}
              icon={checkmarkFill}
              className={classes.box2}
            />
            {item.length ? (
              <Typography className={classes.typography2} variant="body4">
                {item.text.slice(0, item.length)}
                <br />
                {item.text.slice(item.length)}
              </Typography>
            ) : (
              <Typography className={classes.typography2} variant="body4">
                {item.text}
              </Typography>
            )}
          </Stack>
        ))}
      </Stack>

      <div className={classes.flexGrow}></div>

      <CoreButton
        fullWidth
        size="large"
        className={classes.buttonStyle}
        color={action.active === true ? 'secondary' : 'primary'}
        variant={action.active === true ? 'text' : 'contained'}
        disabled={action.disabled === true || loading}
        onClick={() => {
          index !== 3 && onClickHandler()
        }}
        href={
          index === 3 &&
          'https://calendly.com/minicoursegenerator/30min?month=2023-08'
        }
        target="_blank"
      >
        {loading && action.disabled !== true ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          action.text
        )}
      </CoreButton>
    </RootStyle>
  )
}

export default withStyles(styles)(PricingPlanCard)
